import { SetDefaultData, FetchContactTitleRequest, UpdateField, UpdateContactTitleRequest } from '../contact-titles.actions';
import { getUpdateContactTitleState } from '../contact-titles.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Map } from 'immutable';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-update-contact-title',
  templateUrl: './update-contact-title.component.html',
  styleUrls: ['./update-contact-title.component.css']
})
export class UpdateContactTitleComponent extends FormTrait implements OnInit, OnDestroy {

  public isLoading: boolean;
  public userId: number;
  private state$: Subscription;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateContactTitle'))

    this.state$ = this.store.pipe(select(getUpdateContactTitleState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchContactTitleRequest(this.userId))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateContactTitle.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateContactTitle')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required"
    };
    const validator = new Validator(
      {
        name: data.get('name')
      },
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateContactTitleRequest(this.userId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateContactTitle')
      );
    }
  }

}
